'use client';

export default function Advertisement() {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="bg-gradient-to-r from-orange-400 to-orange-600 rounded-lg p-6 text-white text-center">
        <h3 className="text-lg font-semibold mb-2">Advertisement</h3>
        <p className="text-sm opacity-90">Space for your ads</p>
      </div>
    </div>
  );
}
